module.exports = __webpack_public_path__ + "assets/15399cf7463f72d16132584d0d91cdc4.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/BigWin_2.mp3
 ** module id = 214
 ** module chunks = 0
 **/